module.exports = __webpack_public_path__ + "img/back_31.3cc62180.svg";